import { ITranslationSubSchema } from '../../../graphql/type/subSchema/translation';

const language = {
  getText: (translationArr: ITranslationSubSchema[], code?: string): string => {
    if (translationArr && translationArr.length > 0) {
      let translation = translationArr.find(
        (translationItem) => translationItem.la === code
      );

      if (!translation) {
        translation = translationArr.find(
          (translationItem) => translationItem.la === 'en'
        );
      }

      return translation ? translation.text : translationArr[0].text;
    }
    return '';
  },
};
export default language;
